<template>
  <v-container fluid="fluid" grid-list-md="grid-list-md">
    <v-card class="mt-2">
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">Language List</h1>
        </v-toolbar-title>
        <v-btn
          color="teal"
          dark="dark"
          small="small"
          absolute="absolute"
          bottom="bottom"
          right="right"
          fab="fab"
          @click="add"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-layout row>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="search"
              clearable
              append-icon="search"
              label="Search"
              single-line="single-line"
              hide-details="hide-details"
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn round class="mt-3" @click="createUpload" color="info">Create & Upload File</v-btn>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        item-key="id"
        :items="language"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left">{{ props.item.KeyName }}</td>
            <td class="text-xs-left">{{ props.item.English }}</td>
            <td class="text-xs-left">{{ props.item.Spanish }}</td>
            <td class="text-xs-left">{{ props.item.French }}</td>
            <td class="justify-end layout px-0">
              <v-menu bottom="bottom" left="left" offset-y="offset-y">
                <v-btn slot="activator" icon="icon">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list class="menu-button">
                  <v-list-tile @click="edit(props.item)">
                    <v-list-tile-title>{{ $t("buttons.edit") }}</v-list-tile-title>
                  </v-list-tile>
                  <!-- <v-list-tile @click="removeUser(props.item)">
                    <v-list-tile-title>{{ $t("buttons.delete") }}</v-list-tile-title>
                  </v-list-tile> -->
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-alert slot="no-results" :value="true" color="error" icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert
      >
    </v-card>
  </v-container>
</template>

<script>
import languageService from "../service.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      headers: [
        {
          text: "Key",
          value: "KeyName",
          sortable: true
        },
        {
          text: "English",
          value: "English",
          sortable: true
        },
        {
          text: "Spanish",
          value: "Spanish",
          sortable: true
        },
        {
          text: "French",
          value: "French",
          sortable: true
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      search: null,
      language: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "id",
        descending: false
      }
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"])
  },
  async created() {
    await this.getList();
  },
  methods: {
    async createUpload() {
      await languageService.createFile();
      await languageService.uploadFile();
      this.$swal({
        title: "Command Send!",
        text: "Fill will be upload soon!",
        type: "success"
      });
    },
    removeUser(user) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return userService
            .delete(user.id)
            .then(response => {
              if (response.data) {
                this.$swal("Deleted!", "User has been deleted.", "success");
                this.$Progress.finish();
                this.getList();
              }
            })
            .catch(error => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: err.data.message
                });
              this.$Progress.fail();
            });
        }
      });
    },
    add() {
      this.$router.push({ path: `/language/create` });
    },
    edit(data) {
      this.$router.push({ path: `/language/edit/${data.id}` });
    },
    getList() {
      this.loading = true;
      languageService.getAll().then(response => {
        this.language = response.data;
        this.loading = false;
      });
    }
  }
};
//have removed assignedUser
</script>
